import React, { useState } from 'react';
import { Modal } from 'antd';

export default function SprintAIInsights({ insights }) {
    const [selectedInsight, setSelectedInsight] = useState(null);

    return (
        <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-[#e7e8e9] dark:border-slate-700 shadow-sm p-4 w-full h-full flex flex-col">
            <div className="flex items-center gap-2 mb-4">
                <span className="material-symbols-outlined text-[#003263] dark:text-[#a7c8ff]" style={{ fontFamily: 'Material Symbols Outlined' }}>smart_toy</span>
                <h2 className="text-lg font-black text-[#003263] dark:text-[#a7c8ff] font-headline">Sprint AI Assistant</h2>
            </div>
            <div className="space-y-3 flex-1 overflow-y-auto pr-1">
                {insights && insights.map((insight, index) => {
                    let containerClass = "p-3 rounded-lg border cursor-pointer transition-all hover:shadow-md hover:-translate-y-0.5";
                    let titleClass = "text-sm font-bold flex justify-between items-center";
                    
                    if (insight.type === 'error') {
                        containerClass += " bg-red-300/10 border-red-300/20 hover:bg-red-300/20";
                        titleClass += " text-red-900 dark:text-red-400";
                    } else if (insight.type === 'warning') {
                        containerClass += " bg-amber-300/10 border-amber-300/20 hover:bg-amber-300/20";
                        titleClass += " text-amber-800 dark:text-amber-400";
                    } else {
                        containerClass += " bg-blue-100/50 border-blue-200 dark:bg-blue-900/20 dark:border-blue-800 hover:bg-blue-100";
                        titleClass += " text-blue-800 dark:text-blue-300";
                    }

                    return (
                        <div key={index} className={containerClass} onClick={() => insight.relatedTasks?.length > 0 && setSelectedInsight(insight)}>
                            <div className={titleClass}>
                                {insight.title}
                                {insight.relatedTasks?.length > 0 && (
                                    <span className="material-symbols-outlined text-[14px]">arrow_forward_ios</span>
                                )}
                            </div>
                            <p className="text-xs text-[#737782] dark:text-slate-400 mt-1">{insight.message}</p>
                        </div>
                    );
                })}
            </div>

            <Modal
                open={!!selectedInsight}
                onCancel={() => setSelectedInsight(null)}
                footer={null}
                title={selectedInsight && (
                    <div className="flex items-center gap-2">
                        <span className="material-symbols-outlined text-[#003263]">{selectedInsight.icon}</span>
                        <span>{selectedInsight.title} Tasks</span>
                    </div>
                )}
            >
                <div className="py-4 max-h-[60vh] overflow-y-auto">
                    <p className="text-sm text-gray-600 mb-4 bg-gray-50 p-3 rounded-lg border border-gray-100">{selectedInsight?.message}</p>
                    <div className="space-y-2">
                        {selectedInsight?.relatedTasks?.map(task => (
                            <div key={task._id} className="p-3 border rounded-lg hover:bg-gray-50 flex items-center justify-between">
                                <div>
                                    <p className="text-xs font-bold text-[#003263] truncate w-64">{task.title}</p>
                                    <p className="text-xs text-gray-500">{task.project?.name || 'No Project'}</p>
                                </div>
                                <span className={`text-sm font-bold px-2 py-1 rounded 
                                    ${task.status === 'Completed' ? 'bg-emerald-100 text-emerald-800' : 
                                      task.status === 'On Hold' ? 'bg-orange-100 text-orange-800' : 
                                      task.status === 'Under Review' ? 'bg-amber-100 text-amber-800' : 'bg-blue-100 text-blue-800'}`}>
                                    {task.status}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </Modal>
        </div>
    );
}
